'use client';

import Header from 'components/gruenland/organisms/header/Header';
import { HeaderProps } from 'components/gruenland/organisms/header/types';
import { LineItem as WishlistLineItem } from 'types/entity/wishlist';
import { useCart, useWishlist } from 'frontastic/hooks';
import { TasticProps } from 'frontastic/tastics/types';

const HeaderTastic = ({ data, categories }: TasticProps<HeaderProps>) => {
  const {
    data: cart,
    isEmpty,
    totalItems: totalCartItems,
    addItem,
    removeItem,
    updateItem,
    redeemDiscountCode,
    removeDiscountCode,
  } = useCart();

  const { data: wishlist, totalItems: totalWishlistItems, removeLineItem, deleteWishlist } = useWishlist();

  return (
    <div id="header-container">
      <Header
        cart={cart}
        isEmpty={isEmpty}
        onApplyDiscountCode={redeemDiscountCode}
        onRemoveDiscountCode={removeDiscountCode}
        onRemoveItem={removeItem}
        onUpdateItem={updateItem}
        wishlist={wishlist}
        onRemoveFromWishlist={async (lineItemId) => {
          if (wishlist) {
            await removeLineItem(
              wishlist,
              wishlist.lineItems?.find((item) => item.lineItemId === lineItemId) as WishlistLineItem,
            );
          }
        }}
        onMoveToCart={async (lineItem: WishlistLineItem) => {
          if (wishlist && lineItem.variant) {
            await removeLineItem(
              wishlist,
              wishlist.lineItems?.find((item) => item.lineItemId === lineItem.lineItemId) as WishlistLineItem,
            );

            await addItem(lineItem, lineItem.variant, 1);
          }
        }}
        onClearWishlist={async () => {
          if (wishlist) deleteWishlist(wishlist);
        }}
        totalCartItems={totalCartItems}
        totalWishlistItems={totalWishlistItems}
        navLinks={categories?.filter((category) => category.depth === 0)}
        categories={categories}
        tiles={data.tiles}
        col1Label={data.col1Label}
        col1Links={data.col1Links}
        juniorLogoCategories={data.juniorLogoCategories}
      />
    </div>
  );
};
export default HeaderTastic;
